











































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { curCoreClient, CoreClient } from '@/services/CoreClient';
import { curDeviceService, DeviceService} from '@/services/DeviceService';
// import { curApiClient, ApiClient } from '@/services/CoreClient';
// import { curApiService, ApiService } from '@/services/ApiService';

import { User, Info, Device, Channel, Reading } from '@/types/core';

import VueError from '@/components/VueError.vue';
import PleaseWait from '@/components/PleaseWait.vue';
import Spinner from '@/components/Spinner.vue'
import Loading from '@/components/Loading.vue'

import moment from 'moment';
import tippy from 'tippy.js';
import fileDownload from 'js-file-download';

const iconObject = {
  'digital': { src:"digital.svg"},
  'analog': {src:"gauge.svg"},
  'light': {src:"illuminance.svg"},
  'temperature': {src:"temp.svg"},
  'acceleration': {src:"accel.svg"},
  'pressure': {src:"barometer.svg"},
  'gps': {src:"gps.svg"},
  'humidity': {src:"humidity.svg"},
  'time': {src:"time.svg"},
  'voltage': {src:"voltage.svg"},
  'percentage': {src:"percentage.svg", height: 14}
}

@Component({
  components:{
    Loading,
    VueError,
    PleaseWait,
    Spinner
  }
})
export default class ReadingTable extends Vue {

  //TODO reimagine this guy as a horizontal table

  
  @Prop({ default: '',  type: String}) deviceId!: string;
  @Prop({ default: () => [],  type: Array}) channelList!: Channel[];

  error:string = '';
  pleaseWait:string = '';
  selectedCh:number = -1;
  httpBusy:boolean = false;
  icons = iconObject;

  // to support the header
  
  // internal dependencies
  private coreClient:CoreClient = curCoreClient;
  private deviceService:DeviceService = curDeviceService;
    
  async mounted() {
    this.selectedCh = -1;
    tippy('[data-tippy-content]');
  }

  selectChannel(channel:Channel) {
    
    // we blur to remove automatic focus
    // @ts-ignore
    this.$refs[`view-btn-${channel.channelId}`][0].blur();

    this.selectedCh = channel.channelId;

    this.$emit('select-channel', channel);
  }

  canExport():boolean {
    return !this.httpBusy;
  }

  async exportChannel(channel:Channel, numDays:number) {

    let fromTs:number = moment().subtract(numDays, 'days').valueOf();
    let toTs:number = moment().valueOf();

    console.log(`Exporting data from ${fromTs} to ${toTs} (${moment(fromTs)} - ${moment(toTs)}`);

    let rawReadingList:Reading[];

    this.httpBusy = true;
    this.pleaseWait = `export for the last ${numDays} days in progress - please wait`;

    try {
      rawReadingList = await this.deviceService.getDeviceChannelReadings({
        deviceId: this.deviceId,
        channelId: channel.channelId,
        fromTs: fromTs,
        toTs: toTs,
      });
    } catch(err) {
      console.log(err);
      return this.showError(`Unable to retrieve readings for channel ${channel.channelId}: ${(err as Error).message ? (err as Error).message : err}`);
    } finally {
      this.httpBusy = false;
      this.pleaseWait = ''
    }

    if(rawReadingList.length === 0)
      return this.showError(`No readings to export for channel ${channel.channelId} for the last ${numDays} days`);

    let firstReading = rawReadingList[0];
    let lastReading = rawReadingList[rawReadingList.length -1];

    let retList:string[] = [];

    if(typeof firstReading.value === 'object' && firstReading.value.lat && firstReading.value.long)
      retList.push(`time,type,unit,lat,long,label,out-of-order,local time`);
    else if(typeof firstReading.value === 'object' && firstReading.value.x && firstReading.value.y && firstReading.value.z)
      retList.push(`time,type,unit,x,y,z,label,out-of-order,local time`);
    else
      retList.push(`time,type,unit,value,label,out-of-order,local time`);

    for(let reading of rawReadingList) {

      let row = [];
      row.push(moment(reading.ts).toISOString());
      row.push(reading.type);
      row.push(reading.unit);

      if(typeof reading === 'object' && reading.value.lat && reading.value.long)
        row.push(reading.value.lat, reading.value.long);
      else if(typeof reading === 'object' && reading.value.x && reading.value.y && reading.value.z)
        row.push(reading.value.x, reading.value.y, reading.value.z);
      else
        row.push(JSON.stringify(reading.value));

      row.push(reading.label);

      row.push(reading.outOfOrderUplinkCnt ? 'out-of-order-by-uplink-count' :
          reading.outOfOrderTs ? 'out-of-order-by-time' : '');

      row.push(moment(reading.ts).format('YYYY-MM-DD HH:mm:ss'));

      retList.push(row.join(','));
    }

    let filename = `export-${this.deviceId}-ch${channel.channelId}-${moment(firstReading.ts).toISOString(true)}-${moment(lastReading.ts).toISOString(true)}.csv`;

    fileDownload(retList.join("\n"), filename);
  }

  showErrorTimeout:number = 0;
  showError(str:string) {

    this.error = str;

    if(this.showErrorTimeout)
      clearTimeout(this.showErrorTimeout);

    this.showErrorTimeout = window.setTimeout(() => this.error = '', 3000);
  }

}

